<template>
    <p class="page-container">正在努力加载中...</p>
</template>

<script>
import { GetUserSysInfo} from "../api/api";

export default {
    data() {
        return {
            loginUrl:'',
            backUrl:'',
        };
    },
    // mounted() {
    //     var token = this.$cookies.get('access_token');
    //     if(token&&token.length>0)
    //     {
    //         this.startLogin(token);
    //     }else{
    //         this.toLogin();
    //     }
        
    // },
    methods: {
        // //开始登陆
        //  startLogin(token){
        //     GetUserSysInfo({}).then((res) => {
        //         console.log(res);
        //         if(res.code ==0&&res.info)
        //         {          
        //             localStorage.setItem("userid", res.info.userid);
        //             localStorage.setItem("userName", res.info.uname);
        //             localStorage.setItem("userpk", res.info.userpk);
        //             localStorage.setItem("usermappingpk", res.info.usermappingpk);
        //             localStorage.setItem("orgpk", res.info.orgpk);
        //             localStorage.setItem("orgtype", res.info.orgtype);
        //             localStorage.setItem("orgcode", res.info.orgcode);
        //             localStorage.setItem("cnname", res.info.cnname);
        //             localStorage.setItem("enname", res.info.enname);
        //             localStorage.setItem("menuList", JSON.stringify(res.info.menuList)) ;
        //             localStorage.setItem("funcList", JSON.stringify(res.info.funcList));
        //             this.$router.push({ path: "/" });
        //         }else{
        //             this.toLogin();
        //         }
               
        //     }).catch(res =>{
        //         console.log('catch'+res);
        //         this.toLogin();
        //     });
            
        // },
        // toLogin(){
        //     this.$alert('登录失效，请重新登录！', '操作提示', {
        //         confirmButtonText: '确定',
        //         callback: action => {
        //            location.href = "/html/login.html";
        //         }
        //     });
        // }

    }
};
</script>

<style lang="scss" scoped>
    .page-container {
        font-size: 20px;
        text-align: center;
        color: rgb(192, 204, 218);
    }
</style>


// WEBPACK FOOTER //
// Login.vue?0bb4b869